import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Popover,
  Tag,
  Checkbox,
} from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useRef, useState } from 'react';
import {
  createUserGroups,
  editUserGroups,
  getUserGroupsList,
} from '../../../../../../api';
import {
  messageError,
  messageSuccess,
  messageWarning,
} from '../../../../../../components/message';
import { useSelector } from 'react-redux';
import getFormatMessage from '../../../../../../locales/get-format-message';
import {
  IAPIGameItem,
  IAPIStudioMemberHasPermissionItem,
  RoleType,
  IAPIStudioInfo,
  IAuditItem,
} from '../../../../../../model/api-modules';
import { AccessRights } from './access-rights';
import './index.scss';
import classNames from 'classnames';
import EnvDevIcon from '../../../../../../assets/img/env-dev-icon.png';
import EnvLiveIcon from '../../../../../../assets/img/env-live-icon.png';
import closeIcon from '../../../../../../assets/svg/close-icon.svg';
import roleEditIcon from '../../../../../../assets/svg/role-edit-icon.svg';
import roleEditIconHover from '../../../../../../assets/svg/role-edit-icon-hover.svg';
import warnImage from '../../../../../../assets/images/warn-yellow.png';
import { formatEnvCollectionOptions } from '../../../../../game-content/game-filter/env';
import { ModalWrap } from '../../../../../component/modal-wrap';
import { splitEmail } from '../../../../../utils';
import { IRootState } from '../../../../../../store/reducers';
import { PermissionCheck } from '../../../../../component/permission-check';
import {
  IRBACRole,
  IRBACUserGroup,
  RbacRoleObjectKey,
  RbacRoleType,
  RolesDrawerType,
} from '../../../../../../model/rbac';
import { matchMessageCodeFilter } from '../../../../../../lib/code-filter';
import { compareMemberStatus } from './lib';
import { CustomPopover } from '../../../../../../components/custom-popover';
import { eventBus } from '../../../../../../lib';
import { auditWriteLog } from '../../../../../lib/aduit-log';

interface IProps {
  readonly onClose: (status?: boolean) => void;
  readonly type: RolesDrawerType;
  readonly currentRecord: IRBACUserGroup | null;
  readonly studioId: string;
  readonly onUpdate: () => void;
  readonly rolesList: ReadonlyArray<IRBACRole>;
  readonly gameList: ReadonlyArray<IAPIGameItem>;
  readonly allEnvList: any;
  readonly memberList: ReadonlyArray<IAPIStudioMemberHasPermissionItem>;
  readonly studioInfo: IAPIStudioInfo;
  readonly setShowRoleDrawer: (value: boolean) => void;
  readonly setEditType: (value: RolesDrawerType) => void;
  readonly handleMessageResult: (value: any, isCreate?: boolean) => void;
  readonly getMemberStatus: (value: number) => void;
  readonly groupsList: ReadonlyArray<IRBACUserGroup>;
}

const { Option } = Select;

export const GroupsDrawer = (props: IProps) => {
  const [form] = useForm<any>();
  const [accessForm] = useForm<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [init, setInit] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [memberList, setMemberList] = useState<any[]>([]);
  const [confirmDiscardModal, setConfirmDiscardModal] =
    useState<boolean>(false);
  const [fields, setFields] = useState<
    Array<{
      role: number | null;
      game: string | 'all' | null;
      env: number[] | ['all'];
    }>
  >([{ role: null, game: null, env: [] }]);
  const [selectMembers, setSelectMembers] = useState<string[]>([]);
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const userId = userInfo?.UserID;
  const timeoutRef = useRef<any>(null);
  const getModalTitle = () => {
    if (props.type === RolesDrawerType.View) {
      return props.currentRecord?.groupName;
    }
    if (props.type === RolesDrawerType.Edit) {
      return getFormatMessage('edit_group');
    }
    return getFormatMessage('add_new_group');
  };

  const getIsEditDisabled = () => {
    if (
      props.type === RolesDrawerType.Edit &&
      (props.currentRecord?.groupName === 'Editor Group' ||
        props.currentRecord?.groupName === 'Viewer Group' ||
        props.currentRecord?.groupName === 'Admin Group')
    ) {
      return true;
    }
    return false;
  };

  const getEditDisabledDesc = () => {
    if (props.currentRecord?.groupName === 'Editor Group') {
      return getFormatMessage('groups_editor_desc');
    }
    if (props.currentRecord?.groupName === 'Viewer Group') {
      return getFormatMessage('groups_viewer_desc');
    }
    if (props.currentRecord?.groupName === 'Admin Group') {
      return getFormatMessage('groups_admin_desc');
    }
    return props.currentRecord?.desc || '';
  };

  const addRole = () => {
    props.onClose();
    props.setShowRoleDrawer(true);
  };

  const fieldsIsChange = () => {
    if (props.type === RolesDrawerType.Create) {
      if (
        fields.length > 1 ||
        fields[0].role ||
        fields[0].game ||
        fields[0].env.length !== 0
      ) {
        return true;
      }
    }
    if (props.type === RolesDrawerType.Edit) {
      const currentFields: any = [];
      props.currentRecord?.roles.forEach((item) => {
        // 游戏只有单选和全选 全选scope是[]
        currentFields.push({
          role: item.roleId,
          game: item.scope === 0 ? 'all' : item.scope[0].gameId.toString(),
          env:
            item.scope === 0 || item.scope[0].envId === 0
              ? ['all']
              : item.scope[0].envId,
        });
      });
      if (fields.length !== currentFields.length) {
        return true;
      }
      let isChange = false;
      fields.forEach((item, index) => {
        if (
          item.role !== currentFields[index].role ||
          item.game !== currentFields[index].game ||
          JSON.stringify(item.env.sort()) !==
            JSON.stringify(currentFields[index].env.sort())
        ) {
          isChange = true;
        }
      });
      return isChange;
    }
    return false;
  };

  const handleOpenCancel = async () => {
    const values = await form.validateFields();
    if (props.type === RolesDrawerType.Create) {
      if (
        values.GroupName ||
        values.Description ||
        (values.GroupMember && values.GroupMember.length !== 0) ||
        fieldsIsChange()
      ) {
        setConfirmDiscardModal(true);
        return;
      }
    }
    if (props.type === RolesDrawerType.Edit) {
      const oldMembers = JSON.parse(
        JSON.stringify(props.currentRecord?.members)
      );
      if (
        values.GroupName !== props.currentRecord?.groupName ||
        values.Description !== getEditDisabledDesc() ||
        JSON.stringify(values.GroupMember.sort()) !==
          JSON.stringify(oldMembers.sort()) ||
        fieldsIsChange()
      ) {
        setConfirmDiscardModal(true);
        return;
      }
    }
    form.resetFields();
    props.onClose();
  };

  const getMergeFields = (
    fields: Array<{
      role: number | null;
      game: string | 'all' | null;
      env: number[] | ['all'];
    }>
  ) => {
    const merged: {
      [key: string]: {
        role: number | null;
        game: string | 'all' | null;
        env: number[] | ['all'];
      };
    } = {};

    fields.forEach((field) => {
      if (!merged[`${field.role}-all`]) {
        const key = `${field.role}-${field.game}`;
        // 如果game为'all'，则将所有相同role的条目合并为game为'all'
        if (field.game === 'all') {
          merged[`${field.role}-all`] = {
            role: field.role,
            game: 'all',
            env: ['all'],
          };
        } else {
          // 合并其他条目
          if (!merged[key]) {
            merged[key] = { ...field };
          } else {
            // 如果已有条目且env不为['all']
            if (merged[key].env[0] === 'all' || field.env[0] === 'all') {
              merged[key].env = ['all'];
            } else {
              const mergedEnv: any = merged[key].env;
              const filedEnv: any = field.env;
              merged[key].env = Array.from(
                new Set([...mergedEnv, ...filedEnv])
              );
            }
          }
        }
      }
    });

    // eslint-disable-next-line no-restricted-syntax
    for (const key in merged) {
      const [role, game] = key.split('-');
      if (game !== 'all' && merged[`${role}-all`]) {
        delete merged[key];
      }
    }

    return Object.values(merged);
  };

  const getMergeRoles = (
    fields: Array<{
      role: number | null;
      game: string | 'all' | null;
      env: number[] | ['all'];
    }>
  ) => {
    let roles: any = [];
    const mergeFields = getMergeFields(fields);
    mergeFields.forEach((item) => {
      const newItem = roles.find((it: any) => it.roleId === item.role);
      const isSelectAllGame = item.game === 'all';
      const isSelectAllEnv = item.env.some((item) => item === 'all');
      if (!newItem) {
        if (item.role && item.game && item.env.length !== 0) {
          const scope = isSelectAllGame
            ? 0
            : [
                {
                  gameId: item.game,
                  envId: isSelectAllEnv ? 0 : item.env,
                },
              ];
          roles.push({
            roleId: item.role,
            scope,
          });
        }
      } else {
        const newRoles: any = [];
        roles.forEach((it: any) => {
          if (it.roleId === item.role) {
            // scope为0的已经合并过了
            const newScope = Object.assign([], it.scope);
            newScope.push({
              gameId: item.game,
              envId: isSelectAllEnv ? 0 : item.env,
            });
            newRoles.push({
              roleId: it.roleId,
              scope: newScope,
            });
          } else {
            newRoles.push(it);
          }
        });
        roles = newRoles;
      }
    });
    return roles;
  };

  useEffect(() => {
    if (props.type === RolesDrawerType.Edit) {
      form.setFieldsValue({
        GroupName: props.currentRecord?.groupName || '',
        Description: getEditDisabledDesc(),
        GroupMember: props.currentRecord?.members,
      });
      const currentFields: any = [];
      props.currentRecord?.roles.forEach((item) => {
        if (item.scope === 0) {
          currentFields.push({
            role: item.roleId,
            game: 'all',
            env: ['all'],
          });
        } else {
          item.scope.forEach((scopeItem) => {
            currentFields.push({
              role: item.roleId,
              game: scopeItem.gameId,
              env: scopeItem.envId === 0 ? ['all'] : scopeItem.envId,
            });
          });
        }
      });
      if (currentFields.length !== 0) {
        setFields(currentFields);
      }
    }
    setInit(true);
  }, [props.type]);

  useEffect(() => {
    getIsDisabled();
  }, [fields]);

  const getIsDisabled = () => {
    const nameValue = form.getFieldValue('GroupName') || '';
    let isCheckAll = true;
    fields.forEach((item) => {
      if (!item.role || !item.game || item.env.length === 0) {
        isCheckAll = false;
      }
    });
    if (!nameValue.trim() || !isCheckAll) {
      setIsDisabled(true);
      return;
    }
    setIsDisabled(false);
  };

  const addViewer = async (values: any) => {
    const removeMember: string[] = [];
    const result = await getUserGroupsList(props.studioId);
    if (result) {
      props.currentRecord &&
        props.currentRecord.members?.length !== 0 &&
        props.currentRecord.members.forEach((item) => {
          // 用户是否还存在用户组
          let itemOnlyOne = true;
          result.forEach((it) => {
            if (it.members.includes(item)) {
              itemOnlyOne = false;
            }
          });
          // 被移除的成员只有一个用户组
          if (
            !(values.GroupMember || []).includes(item) &&
            itemOnlyOne &&
            item !== 'InGame_Support@tencent.com'
          ) {
            removeMember.push(item);
          }
        });
      if (removeMember.length !== 0) {
        const viewItem = props.groupsList.find(
          (item) => item.groupName === 'Viewer Group'
        );
        if (viewItem) {
          const currentMembers = removeMember.concat(viewItem.members);
          await editUserGroups(viewItem.groupId, {
            description: viewItem.desc,
            name: viewItem.groupName,
            roles: Object.assign([], viewItem.roles),
            studioID: props.studioId,
            members: currentMembers,
          });
          props.onUpdate();
        }
      }
    }
  };

  const handleSubmit = async () => {
    const values = await form.validateFields();

    if (!values.GroupName) {
      return messageWarning(getFormatMessage('enter_group_name'));
    }
    let isAllSelect = true;
    fields.forEach((item) => {
      if (!item.role || !item.game || item.env.length === 0) {
        isAllSelect = false;
      }
    });
    if (!isAllSelect) {
      return messageWarning(getFormatMessage('select_scope'));
    }

    setLoading(true);
    try {
      const trimmedName = values.GroupName.trim();
      const roles: any = getMergeRoles(fields);
      const valuesForm = {
        description: values.Description || '',
        name: trimmedName,
        roles,
        studioID: props.studioId,
        members: values.GroupMember || [],
      };
      const originalMembers = props.currentRecord?.members as string[];
      const currentMembers = values.GroupMember;
      const memberStatus = compareMemberStatus(
        userId as string,
        originalMembers,
        currentMembers
      );
      props.getMemberStatus(memberStatus);
      if (props.type === RolesDrawerType.Create) {
        const res = await createUserGroups(valuesForm);
        auditWriteLog(IAuditItem.AddNewOrganizationGroup, {
          detail: valuesForm,
        });
        const isCodeFilter = res?.code && matchMessageCodeFilter(res.code);
        if (res?.code === 0 || isCodeFilter) {
          props.handleMessageResult(res, true);
          props.onUpdate();
          props.onClose();
          return;
        }
        messageError(getFormatMessage('create_fail'));
      } else if (
        props.type === RolesDrawerType.Edit &&
        props.currentRecord?.groupId
      ) {
        const res = await editUserGroups(
          props.currentRecord.groupId,
          valuesForm
        );
        auditWriteLog(IAuditItem.EditOrganizationGroup, {
          detail: {
            groupID: props.currentRecord.groupId,
            ...valuesForm,
          },
        });
        const isCodeFilter = matchMessageCodeFilter(res.code);
        if (res?.code === 0 || isCodeFilter) {
          props.handleMessageResult(res);
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
          timeoutRef.current = setTimeout(() => {
            addViewer(values);
          }, 50);
          messageSuccess(getFormatMessage('edit_success'));
          eventBus.emit('refreshMessages');
          props.onUpdate();
          props.onClose();
          return;
        }
        messageError(getFormatMessage('error_update'));
      }
    } catch (error: any) {
      messageError(
        error?.apiError?.message || getFormatMessage('failed_submit')
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  // 关闭抽屉二次确认
  const confirmDiscardChanges = async () => {
    setConfirmDiscardModal(false);
    form.resetFields();
    props.onClose();
    return true;
  };

  const renderConfirmDiscardModal = () => {
    if (confirmDiscardModal) {
      return (
        <ModalWrap
          width="440px"
          // loading={loading}
          onOk={confirmDiscardChanges}
          cancelText={getFormatMessage('cancel')}
          onClose={() => {
            setConfirmDiscardModal(false);
          }}
          oKText={getFormatMessage('Confirm')}
          title={
            <p className="fail-title">
              <img
                src={warnImage}
                alt="Warning"
                style={{ marginRight: '10px', marginTop: '-2px' }}
              />
              <span>{getFormatMessage('discard_changes')}</span>
            </p>
          }
          className="delete-env-modal delete-modal"
        >
          <div style={{ whiteSpace: 'pre-line' }}>
            {getFormatMessage('sure_discard_changes')}
          </div>
        </ModalWrap>
      );
    }
    return null;
  };

  const renderMemberLabel = (item: IAPIStudioMemberHasPermissionItem) => {
    // const groupValue = form.getFieldValue('GroupMember');
    let userType = '';
    if (item.RbacMember?.some((member) => member.roleType === RoleType.Owner)) {
      userType = 'Owner';
    } else if (
      item.RbacMember?.some((member) => member.roleType === RoleType.Admin)
    ) {
      userType = 'Admin';
    }
    const disabled = !(
      !item.RbacMember?.length ||
      item.RbacMember?.some(
        (member) =>
          member.roleType !== RoleType.Owner &&
          member.roleType !== RoleType.Admin
      )
    );

    return (
      <div className="groups-member-box">
        {/* <Checkbox
          // checked={groupValue && groupValue.indexOf(item.UserID) !== -1}
          disabled={disabled}
        >
        </Checkbox> */}
        <span
          className={classNames(
            'groups-member-name',
            disabled ? 'groups-member-name-disable' : ''
          )}
        >
          {splitEmail(item.UserID)}
        </span>
        {userType && <span className="groups-member-type">{userType}</span>}
        <span
          className={classNames(
            'groups-member-email',
            disabled ? 'groups-member-email-disable' : ''
          )}
        >
          {item.UserID}
        </span>
      </div>
    );
  };

  useEffect(() => {
    const memberList: any[] = [];
    const sortMemberList: IAPIStudioMemberHasPermissionItem[] = Object.assign(
      [],
      props.memberList
    );
    sortMemberList.sort(
      (
        a: IAPIStudioMemberHasPermissionItem,
        b: IAPIStudioMemberHasPermissionItem
      ) => {
        let sortNumA = 0;
        let sortNumB = 0;
        if (
          a.RbacMember?.some((member) => member.roleType === RoleType.Owner)
        ) {
          sortNumA = 1;
        } else if (
          a.RbacMember?.some((member) => member.roleType === RoleType.Admin)
        ) {
          sortNumA = 2;
        }
        if (
          b.RbacMember?.some((member) => member.roleType === RoleType.Owner)
        ) {
          sortNumB = 1;
        } else if (
          b.RbacMember?.some((member) => member.roleType === RoleType.Admin)
        ) {
          sortNumB = 2;
        }
        return sortNumA - sortNumB;
      }
    );

    sortMemberList.forEach((item) => {
      if (item.UserID !== 'InGame_Support@tencent.com') {
        memberList.push({
          label: renderMemberLabel(item),
          value: item.UserID,
          disabled:
            props.currentRecord?.groupName !== 'Admin Group'
              ? !(
                  !item.RbacMember?.length ||
                  item.RbacMember?.some(
                    (member) =>
                      member.roleType !== RoleType.Owner &&
                      member.roleType !== RoleType.Admin
                  )
                )
              : !(
                  !item.RbacMember?.length ||
                  item.RbacMember?.some(
                    (member) => member.roleType !== RoleType.Owner
                  )
                ),
        });
      }
    });
    setMemberList(memberList);
  }, [props.memberList]);

  const tagRender = (itemProps: any) => {
    const { value, onClose } = itemProps;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <CustomPopover content={value} placement="topRight">
        <Tag
          onMouseDown={onPreventMouseDown}
          onClose={onClose}
          closable={true}
          style={{ border: 'none', background: '#F2F3F5' }}
        >
          {splitEmail(value)}
        </Tag>
      </CustomPopover>
    );
  };

  const changeMembers = (e: any) => {
    getIsDisabled();
    setSelectMembers(e);
  };

  const renderFormItems = () => {
    return (
      <>
        <div className="drawer-download-h" style={{ marginBottom: '20px' }}>
          {getFormatMessage('basic')}
        </div>
        <div className="drawer-download-text">
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="GroupName"
                label={
                  <div>
                    {getFormatMessage('group_name')}{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </div>
                }
                // rules={[{ required: true }]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                {getIsEditDisabled() ? (
                  <CustomPopover
                    content={getFormatMessage('gourps_modified_tips')}
                  >
                    <div>
                      <Input
                        placeholder={getFormatMessage('enter_name_of_group')}
                        style={{ minHeight: '32px' }}
                        disabled
                        value={props.currentRecord?.groupName || ''}
                      />
                    </div>
                  </CustomPopover>
                ) : (
                  <Input
                    placeholder={getFormatMessage('enter_name_of_group')}
                    onChange={getIsDisabled}
                    style={{ minHeight: '32px' }}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="Description"
                label={getFormatMessage('description')}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                {getIsEditDisabled() ? (
                  <CustomPopover
                    content={getFormatMessage('gourps_modified_tips')}
                  >
                    <div>
                      <Input.TextArea
                        placeholder={getFormatMessage('enter_description')}
                        style={{ minHeight: '66px' }}
                        disabled
                        value={getEditDisabledDesc()}
                      />
                    </div>
                  </CustomPopover>
                ) : (
                  <Input.TextArea
                    placeholder={getFormatMessage('enter_description')}
                    style={{ minHeight: '66px' }}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div className="drawer-download-h" style={{ marginTop: '16px' }}>
          {getFormatMessage('access_rights')}
          <div
            className="view-title role-and-scope"
            style={{ marginTop: '20px', marginBottom: '8px' }}
          >
            {getFormatMessage('role_and_scope')}
            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
          </div>
        </div>
        <AccessRights
          rolesList={props.rolesList}
          gameList={props.gameList}
          studioId={props.studioId}
          allEnvList={props.allEnvList}
          fields={fields}
          setFields={setFields}
          accessForm={accessForm}
          addRole={addRole}
          disabled={getIsEditDisabled()}
        />
        <div
          className="drawer-download-text group-member-select-box"
          style={{ marginTop: '20px' }}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="GroupMember"
                label={getFormatMessage('group_member')}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Select
                  placeholder={getFormatMessage('select_member_of_group')}
                  // options={memberList}
                  showSearch={true}
                  mode="multiple"
                  maxTagCount="responsive"
                  onChange={(e) => changeMembers(e)}
                  virtual={false}
                  className="member-select-box"
                  tagRender={tagRender}
                  popupClassName="member-select-box-popup"
                >
                  {memberList.map((option) => {
                    return (
                      <Option
                        key={option.value}
                        value={option.value}
                        disabled={option.disabled}
                        style={option.styles}
                      >
                        <div className="group-role">
                          <Checkbox
                            value={option.value}
                            checked={selectMembers.includes(option.value)}
                          />
                          <span>{option.label}</span>
                        </div>
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </div>
        {renderConfirmDiscardModal()}
      </>
    );
  };

  const renderViewItem = () => {
    const currentMembers =
      props.currentRecord?.members.filter(
        (item) => item !== 'InGame_Support@tencent.com'
      ) || [];
    return (
      <div className="group-view-box">
        <div className="view-title">{getFormatMessage('description')}</div>
        <div className="view-desc">{getEditDisabledDesc()}</div>
        <div className="view-title">{getFormatMessage('access_rights')}</div>
        <div className="view-access-rights">
          {props.currentRecord?.roles.length !== 0 &&
            props.currentRecord?.roles.map((role, index) => {
              const roleItem = props.rolesList.filter(
                (item) => item.roleId === role.roleId
              );
              let roleName = roleItem[0].roleName || '';
              if (roleItem[0].type !== RbacRoleType.Custom && roleName) {
                roleName =
                  roleName.slice(0, 1).toUpperCase() + roleName.slice(1);
              }
              return (
                <div
                  className={classNames(
                    'view-access-rights-item',
                    index !== 0 ? 'item-border-top' : ''
                  )}
                >
                  <div
                    className="view-access-rights-item-col"
                    style={{ marginBottom: '8px' }}
                  >
                    <div className="view-access-rights-left">
                      {getFormatMessage('view_show_role')}
                    </div>
                    <div className="view-access-rights-role">{roleName}</div>
                  </div>
                  <div className="view-access-rights-item-col">
                    <div className="view-access-rights-left">
                      {getFormatMessage('scope')}
                    </div>
                    <div className="view-access-rights-right">
                      {role.scope !== 0 ? (
                        role.scope.map((scope) => {
                          const gameItem = props.gameList.filter(
                            (item) => item.gameID === scope.gameId
                          );
                          return (
                            <div className="view-access-rights-right-item">
                              <div className="view-access-rights-game">
                                {gameItem.length !== 0
                                  ? gameItem[0].gameName
                                  : ''}
                              </div>
                              <div className="view-access-rights-env">
                                {scope.envId !== 0 ? (
                                  scope.envId.map((env) => {
                                    const envs = scope.gameId
                                      ? props.allEnvList[scope.gameId]
                                      : [];
                                    const envOptions =
                                      formatEnvCollectionOptions(envs);
                                    const newEnvOption: any = [];
                                    const envItem: any = [];
                                    envOptions.forEach((item) => {
                                      item.children?.forEach((it) => {
                                        if (it.envIncrementID === env) {
                                          newEnvOption.push(item);
                                          envItem.push(it);
                                        }
                                      });
                                    });
                                    if (
                                      envItem.length !== 0 &&
                                      newEnvOption.length !== 0
                                    ) {
                                      return (
                                        <div className="view-access-rights-env-item">
                                          {envItem[0].envType === 'DEV' && (
                                            <img
                                              src={EnvDevIcon}
                                              className="access-right-env-type"
                                            />
                                          )}
                                          {envItem[0].envType === 'LIVE' && (
                                            <img
                                              src={EnvLiveIcon}
                                              className="access-right-env-type"
                                            />
                                          )}
                                          <Popover
                                            overlayClassName="info-item-popover"
                                            content={`${newEnvOption[0].label} - ${envItem[0].envName}`}
                                            trigger="hover"
                                            placement="topLeft"
                                          >
                                            <span
                                              style={{ cursor: 'default' }}
                                            >{`${newEnvOption[0].label} - ${envItem[0].envName}`}</span>
                                          </Popover>
                                        </div>
                                      );
                                    }
                                    return null;
                                  })
                                ) : (
                                  <div className="view-access-rights-env-item">
                                    {getFormatMessage('all_env')}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="view-access-rights-right-item">
                          {getFormatMessage('view_all')}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        {/* 排除InGame_Support@tencent.com */}
        {currentMembers.length !== 0 && (
          <div className="view-title">{getFormatMessage('group_member')}</div>
        )}
        {currentMembers.length !== 0 && (
          <div className="view-group-member">
            {currentMembers.map((member, index) => {
              const memberItem = props.memberList.filter(
                (item) => item.UserID === member
              );
              return (
                <div
                  className={classNames(
                    'view-group-member-item',
                    index !== 0 ? 'item-border-top' : ''
                  )}
                >
                  <div className="view-group-member-item-left">
                    {memberItem.length !== 0
                      ? memberItem[0].UserName
                      : member.split('@')[0]}
                    {userInfo?.UserID === member && (
                      <span className="you-marker">YOU</span>
                    )}
                  </div>
                  <div className="view-group-member-item-right">{member}</div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  if (!init) return null;
  return (
    <Drawer
      className="group-drawer"
      onClose={handleOpenCancel}
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>{getModalTitle()}</span>
          <img
            src={closeIcon}
            className="sync-close-icon"
            onClick={handleOpenCancel}
          />
        </div>
      }
      placement="right"
      width={props.type === RolesDrawerType.View ? 720 : 1032}
      closable={false}
      visible={true}
      headerStyle={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        marginLeft: '3px',
      }}
      footer={
        <div
          style={{
            textAlign: 'left',
          }}
        >
          <button
            className="gc-btn sub-button"
            onClick={handleOpenCancel}
            disabled={loading}
          >
            {props.type === RolesDrawerType.View
              ? getFormatMessage('close')
              : getFormatMessage('cancel')}
          </button>
          {props.type !== RolesDrawerType.View ? (
            <Button
              className="gc-btn gc-btn-primary gc-btn-download"
              loading={loading}
              onClick={handleSubmit}
              disabled={isDisabled}
            >
              {getFormatMessage('submit')}
            </Button>
          ) : (
            <PermissionCheck
              permissionKey={RbacRoleObjectKey.UserGroupCreate}
              tipsPlacement="left"
            >
              <button
                className="gc-btn sub-button role-view-edit-btn"
                onClick={() => props.setEditType(RolesDrawerType.Edit)}
                disabled={loading}
              >
                <div className="role-view-edit">
                  <img src={roleEditIcon} className="role-edit-icon" />
                  <img
                    src={roleEditIconHover}
                    className="role-edit-icon-hover"
                  />
                  {getFormatMessage('edit')}
                </div>
              </button>
            </PermissionCheck>
          )}
        </div>
      }
    >
      <Form form={form}>
        {props.type === RolesDrawerType.View
          ? renderViewItem()
          : renderFormItems()}
      </Form>
    </Drawer>
  );
};
